<template>
    <h1 class="datepicker__container">
        <span class="row">
            <span class="col-xs-12 col-sm-6">
                {{$t('dashboard.datepickers.from')}}
                <datepicker class="datepicker" v-model="start" :disabledDates="{from: end}" :highlighted="{from:start, to:end}"/>
            </span>
            <span class="col-xs-12 col-sm-6">
                {{$t('dashboard.datepickers.to')}}
                <datepicker class="datepicker" v-model="end" :disabledDates="{to: start}" :highlighted="{from:start, to:end}"/>
            </span>
        </span>
    </h1>
</template>
<script>
    import Vue from 'vue';
    import {Component, Model} from 'vue-property-decorator';
    import Datepicker from '../general/Datepicker';
    import moment from 'moment';

    @Component({
        components: {
            Datepicker
        }
    })
    export default class DaterangePicker extends Vue {
        @Model({
            type: Object,
            default: () => ({
                begin: null,
                end: null,
            })
        })
        daterange;

        get start() {
            return this.daterange.start.toDate();
        }

        set start(value) {
            this.daterange.start = moment(value);
        }

        get end() {
            return this.daterange.end.toDate();
        }

        set end(value) {
            this.daterange.end = moment(value);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DaterangePicker.vue